import { Award } from "lucide-react";

/**
 * Veteran-founded badge. Two variants:
 *   - "pill": stone chip for use on light sections (hero, cards)
 *   - "inline": tiny label next to the brand name in the header
 *   - "dark": onyx pill for use on dark backgrounds
 * Accepts an optional `text` prop; defaults to "Veteran-Founded · Woman-Owned".
 */
export default function VeteranBadge({ variant = "pill", className = "", text }) {
  const label = (text && text.trim()) || "Veteran-Founded · Woman-Owned";
  if (variant === "inline") {
    return (
      <span
        data-testid="veteran-badge-inline"
        className={`hidden lg:inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.22em] text-stone-500 font-sans font-medium border border-stone-300 rounded-full px-2 py-0.5 ml-2 ${className}`}
        title={label}
      >
        <Award strokeWidth={1.75} className="w-3 h-3" /> Vet-Founded
      </span>
    );
  }

  if (variant === "dark") {
    return (
      <span
        data-testid="veteran-badge-dark"
        className={`inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.25em] text-[#F9F9F6] font-sans font-medium bg-[#1A1C1A]/90 backdrop-blur rounded-full px-3 py-1.5 ${className}`}
      >
        <Award strokeWidth={1.75} className="w-3.5 h-3.5" /> {label}
      </span>
    );
  }

  return (
    <span
      data-testid="veteran-badge"
      className={`inline-flex items-center gap-1.5 text-[10px] md:text-[11px] uppercase tracking-[0.25em] text-[#1A1C1A] font-sans font-medium bg-[#F4F1EA] border border-stone-300 rounded-full px-3 py-1.5 ${className}`}
    >
      <Award strokeWidth={1.75} className="w-3.5 h-3.5" /> {label}
    </span>
  );
}
